import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'state/store';

import { useVerificationValidation } from './useVerificationValidation';
import { isVerificationBlocking } from './verificationHelpers';

export const useShouldDisableNavigation = (): boolean => {
  const { idVerification, incomeVerification } = useSelector(
    (state: RootState) => state.idIncomeVerification,
  );

  // Memoize the blocking calculation to avoid unnecessary recalculations
  const shouldDisableNavigation = useMemo(() => {
    const isIdBlocking = isVerificationBlocking(idVerification);
    const isIncomeBlocking = isVerificationBlocking(incomeVerification);
    return isIdBlocking || isIncomeBlocking;
  }, [idVerification, incomeVerification]);

  // Manage validation state (side effect delegated to separate hook)
  useVerificationValidation(shouldDisableNavigation);

  return shouldDisableNavigation;
};
